import './ServicesSectionSkeleton.scss';

const ServicesSectionSkeleton = () => {

  return (
    <div className="home__services__section__skeleton">
      <div className="left__side__services__section__skeleton">
        <div className="services__content__skeleton">
          <div className="services__accent__skeleton"></div>
            <div className="services__title__skeleton"></div>
          <div className="services__title__skeleton--primary"></div>
          {[...Array(4)].map((_, i) => (
            <div key={i} className="services__subtitle__skeleton"></div>
          ))}
          <div className="services__subtitle__skeleton--primary"></div>
          <div className="services__button__skeleton">
          </div>
        </div>
      </div>
      <div className="right__side__services__section__skeleton">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="services__links__item__skeleton">
            <div className="link__item__skeleton"></div>
            <div className="link__item__skeleton--primary"></div>
            {[...Array(4)].map((_, i) => (
              <div key={i} className="services__link__text__skeleton"></div>
            ))}
            <div className="services__link__text__skeleton--primary"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesSectionSkeleton;